export const figure13c = {
    chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
        plotBackgroundColor: null,
        plotBorderWidth: null,
      },
      credits: {
        enabled: false
    },
      title: {
          text: 'République-Unie de Tanzanie'
      },
      subtitle: {
        text: null
    },
      xAxis: {
        categories: ['2009','2011','2013', '2015']
      },
      labels: {
        
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      yAxis: {
        min: 0,
        max: 8,
        tickInterval: 2,
        title: {
            text: null,
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
    },
    legend: {
        enabled: false,
    },
      colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
      series: [{
        name: 'Petites exploitations',
        data: [3.2, 3.4, 3.6, 4.0,]
      }, {
        name: 'Autres exploitations',
        data: [4.2, 5.4, 5.5, 6.0,]
      },{
        name: 'Petites exploitations dirigées par une femme',
        data: [3.2, 3.2, 3.3, 3.8,]
      },{
        name: 'Petites exploitations dirigées par un homme',
        data: [3.2, 3.5, 3.7, 4.1,]
      }]
    }

    